import { CModal, CModalHeader } from "@coreui/react";
import { QrCodeIcon } from "@heroicons/react/24/outline";
import {
  ArrowTopRightOnSquareIcon,
  LockClosedIcon,
} from "@heroicons/react/24/solid";
import React from "react";
import { Link } from "react-router-dom";
import { getPlaceMoreLinks } from "./placeUtils";

function MoreItem({
  icon,
  label,
  to,
  onClick,
}: {
  icon: React.ReactNode;
  label: string;
  to?: string;
  onClick?: () => void;
}) {
  const className =
    "d-flex align-items-center gap-3 p-2 rounded-3 text-decoration-none text-reset border-0 bg-transparent w-100";
  const inner = (
    <>
      <span
        className="d-inline-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
        style={{ width: 36, height: 36, backgroundColor: "#f5f5f5" }}
      >
        {icon}
      </span>
      <span className="fw-semibold flex-grow-1 text-start">{label}</span>
    </>
  );

  return to ? (
    <Link to={to} className={className}>
      {inner}
    </Link>
  ) : (
    <button type="button" onClick={onClick} className={className}>
      {inner}
    </button>
  );
}

interface Props {
  place: Place;
  visible: boolean;
  isAdmin: boolean;
  onClose: () => void;
  onQr: () => void;
  onResetPassword: () => void;
}

export default function MoreActionsModal({
  place,
  visible,
  isAdmin,
  onClose,
  onQr,
  onResetPassword,
}: Props) {
  return (
    <CModal
      visible={visible}
      onClose={onClose}
      alignment="center"
      backdrop="static"
    >
      <CModalHeader>
        <h5 className="fs-5 fw-bold mb-0">Contenu complémentaire</h5>
      </CModalHeader>
      <div className="d-flex flex-column gap-1 p-3">
        {getPlaceMoreLinks(place).map(
          ({ label, to, icon: Icon = ArrowTopRightOnSquareIcon }) => (
            <MoreItem
              key={to}
              to={to}
              label={label}
              icon={<Icon width="16" height="16" />}
            />
          ),
        )}
        <MoreItem
          label="Qrcode"
          icon={<QrCodeIcon width="16" height="16" />}
          onClick={onQr}
        />
        {isAdmin && (
          <MoreItem
            label="Réinitialiser le mot de passe"
            icon={<LockClosedIcon width="16" height="16" />}
            onClick={onResetPassword}
          />
        )}
      </div>
    </CModal>
  );
}